var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(_vm.componentName,{tag:"component"},[_c('router-view')],1),(_vm.isAuth)?_c('ChatHelp'):_vm._e(),_c('ChangeUnityProfile'),_c('Password'),_c('Snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }